export const productSeries = [
  {
    "slug": "streamline",
    "name": "流线",
    "code": "STREAM",
    "concept": "line / motion",
    "folder": "streamline",
    "desc": "流线系列把银饰做成贴近手部动作的连续线条，像被日常磨亮的轨迹，轻、准，也保留一点速度感。",
    "detail": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。",
    "cover": "/products/streamline/IMG_5355-web.jpg",
    "products": [
      {
        "id": "streamline-01",
        "name": "流线01",
        "code": "JM-STREAM-01",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5355-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-02",
        "name": "流线02",
        "code": "JM-STREAM-02",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5356-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-03",
        "name": "流线03",
        "code": "JM-STREAM-03",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5357-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-04",
        "name": "流线04",
        "code": "JM-STREAM-04",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5370-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-05",
        "name": "流线05",
        "code": "JM-STREAM-05",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5371-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-06",
        "name": "流线06",
        "code": "JM-STREAM-06",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5373-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-07",
        "name": "流线07",
        "code": "JM-STREAM-07",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5374-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-08",
        "name": "流线08",
        "code": "JM-STREAM-08",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5375-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-09",
        "name": "流线09",
        "code": "JM-STREAM-09",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5377-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-10",
        "name": "流线10",
        "code": "JM-STREAM-10",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5380-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-11",
        "name": "流线11",
        "code": "JM-STREAM-11",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5384-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-12",
        "name": "流线12",
        "code": "JM-STREAM-12",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5385-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-13",
        "name": "流线13",
        "code": "JM-STREAM-13",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5386-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-14",
        "name": "流线14",
        "code": "JM-STREAM-14",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5387-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-15",
        "name": "流线15",
        "code": "JM-STREAM-15",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5395-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-16",
        "name": "流线16",
        "code": "JM-STREAM-16",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5397-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-17",
        "name": "流线17",
        "code": "JM-STREAM-17",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5398-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-18",
        "name": "流线18",
        "code": "JM-STREAM-18",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5404-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-19",
        "name": "流线19",
        "code": "JM-STREAM-19",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5405-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-20",
        "name": "流线20",
        "code": "JM-STREAM-20",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5409-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-21",
        "name": "流线21",
        "code": "JM-STREAM-21",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5410-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-22",
        "name": "流线22",
        "code": "JM-STREAM-22",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5414-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-23",
        "name": "流线23",
        "code": "JM-STREAM-23",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5417-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-24",
        "name": "流线24",
        "code": "JM-STREAM-24",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5419-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-25",
        "name": "流线25",
        "code": "JM-STREAM-25",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5422-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-26",
        "name": "流线26",
        "code": "JM-STREAM-26",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5424-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-27",
        "name": "流线27",
        "code": "JM-STREAM-27",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5425-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-28",
        "name": "流线28",
        "code": "JM-STREAM-28",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5428-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-29",
        "name": "流线29",
        "code": "JM-STREAM-29",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5470-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-30",
        "name": "流线30",
        "code": "JM-STREAM-30",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5472-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-31",
        "name": "流线31",
        "code": "JM-STREAM-31",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5481-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      },
      {
        "id": "streamline-32",
        "name": "流线32",
        "code": "JM-STREAM-32",
        "seriesSlug": "streamline",
        "seriesName": "流线",
        "price": 899,
        "image": "/products/streamline/IMG_5484-web.jpg",
        "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
      }
    ]
  },
  {
    "slug": "chain",
    "name": "链条",
    "code": "CHAIN",
    "concept": "connection / relation",
    "folder": "chain",
    "desc": "链条系列把连接关系留在首饰表面：不是锁死，而是让环节之间保持松动、张力和可以呼吸的距离。",
    "detail": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。",
    "cover": "/products/chain/IMG_5359-web.jpg",
    "products": [
      {
        "id": "chain-01",
        "name": "链条01",
        "code": "JM-CHAIN-01",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_5359-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-02",
        "name": "链条02",
        "code": "JM-CHAIN-02",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_5361-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-03",
        "name": "链条03",
        "code": "JM-CHAIN-03",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_8028-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-04",
        "name": "链条04",
        "code": "JM-CHAIN-04",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_8035-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-05",
        "name": "链条05",
        "code": "JM-CHAIN-05",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_8036-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-06",
        "name": "链条06",
        "code": "JM-CHAIN-06",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_8042-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-07",
        "name": "链条07",
        "code": "JM-CHAIN-07",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_8043-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-08",
        "name": "链条08",
        "code": "JM-CHAIN-08",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_8045-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-09",
        "name": "链条09",
        "code": "JM-CHAIN-09",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_8046-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-10",
        "name": "链条10",
        "code": "JM-CHAIN-10",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_8048-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-11",
        "name": "链条11",
        "code": "JM-CHAIN-11",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_8051-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-12",
        "name": "链条12",
        "code": "JM-CHAIN-12",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_8056-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-13",
        "name": "链条13",
        "code": "JM-CHAIN-13",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_8060-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-14",
        "name": "链条14",
        "code": "JM-CHAIN-14",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_8068-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-15",
        "name": "链条15",
        "code": "JM-CHAIN-15",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_8069-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-16",
        "name": "链条16",
        "code": "JM-CHAIN-16",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_8070-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-17",
        "name": "链条17",
        "code": "JM-CHAIN-17",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_8071-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-18",
        "name": "链条18",
        "code": "JM-CHAIN-18",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_8072-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-19",
        "name": "链条19",
        "code": "JM-CHAIN-19",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_8073-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-20",
        "name": "链条20",
        "code": "JM-CHAIN-20",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_8075-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-21",
        "name": "链条21",
        "code": "JM-CHAIN-21",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_8076-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-22",
        "name": "链条22",
        "code": "JM-CHAIN-22",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_8078-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-23",
        "name": "链条23",
        "code": "JM-CHAIN-23",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_8079-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      },
      {
        "id": "chain-24",
        "name": "链条24",
        "code": "JM-CHAIN-24",
        "seriesSlug": "chain",
        "seriesName": "链条",
        "price": 960,
        "image": "/products/chain/IMG_8083-web.jpg",
        "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
      }
    ]
  },
  {
    "slug": "signal",
    "name": "信号",
    "code": "SIGNAL",
    "concept": "signal / mark",
    "folder": "signal",
    "desc": "信号系列像手上的短讯号，清晰但不过度放大，在细小金属面里留下态度、方向和辨识度。",
    "detail": "信号系列更像一种标记。它用明确的金属形态制造轻微的视觉停顿，让佩戴者在不需要解释自己的时候，仍然拥有可被感知的存在。",
    "cover": "/products/signal/IMG_5363-web.jpg",
    "products": [
      {
        "id": "signal-01",
        "name": "信号01",
        "code": "JM-SIGNAL-01",
        "seriesSlug": "signal",
        "seriesName": "信号",
        "price": 920,
        "image": "/products/signal/IMG_5363-web.jpg",
        "description": "信号系列更像一种标记。它用明确的金属形态制造轻微的视觉停顿，让佩戴者在不需要解释自己的时候，仍然拥有可被感知的存在。"
      },
      {
        "id": "signal-02",
        "name": "信号02",
        "code": "JM-SIGNAL-02",
        "seriesSlug": "signal",
        "seriesName": "信号",
        "price": 920,
        "image": "/products/signal/IMG_5437-web.jpg",
        "description": "信号系列更像一种标记。它用明确的金属形态制造轻微的视觉停顿，让佩戴者在不需要解释自己的时候，仍然拥有可被感知的存在。"
      },
      {
        "id": "signal-03",
        "name": "信号03",
        "code": "JM-SIGNAL-03",
        "seriesSlug": "signal",
        "seriesName": "信号",
        "price": 920,
        "image": "/products/signal/IMG_5439-web.jpg",
        "description": "信号系列更像一种标记。它用明确的金属形态制造轻微的视觉停顿，让佩戴者在不需要解释自己的时候，仍然拥有可被感知的存在。"
      },
      {
        "id": "signal-04",
        "name": "信号04",
        "code": "JM-SIGNAL-04",
        "seriesSlug": "signal",
        "seriesName": "信号",
        "price": 920,
        "image": "/products/signal/IMG_6307-web.jpg",
        "description": "信号系列更像一种标记。它用明确的金属形态制造轻微的视觉停顿，让佩戴者在不需要解释自己的时候，仍然拥有可被感知的存在。"
      },
      {
        "id": "signal-05",
        "name": "信号05",
        "code": "JM-SIGNAL-05",
        "seriesSlug": "signal",
        "seriesName": "信号",
        "price": 920,
        "image": "/products/signal/IMG_6309-web.jpg",
        "description": "信号系列更像一种标记。它用明确的金属形态制造轻微的视觉停顿，让佩戴者在不需要解释自己的时候，仍然拥有可被感知的存在。"
      },
      {
        "id": "signal-06",
        "name": "信号06",
        "code": "JM-SIGNAL-06",
        "seriesSlug": "signal",
        "seriesName": "信号",
        "price": 920,
        "image": "/products/signal/IMG_6316-web.jpg",
        "description": "信号系列更像一种标记。它用明确的金属形态制造轻微的视觉停顿，让佩戴者在不需要解释自己的时候，仍然拥有可被感知的存在。"
      },
      {
        "id": "signal-07",
        "name": "信号07",
        "code": "JM-SIGNAL-07",
        "seriesSlug": "signal",
        "seriesName": "信号",
        "price": 920,
        "image": "/products/signal/IMG_6329-web.jpg",
        "description": "信号系列更像一种标记。它用明确的金属形态制造轻微的视觉停顿，让佩戴者在不需要解释自己的时候，仍然拥有可被感知的存在。"
      },
      {
        "id": "signal-08",
        "name": "信号08",
        "code": "JM-SIGNAL-08",
        "seriesSlug": "signal",
        "seriesName": "信号",
        "price": 920,
        "image": "/products/signal/IMG_6336-web.jpg",
        "description": "信号系列更像一种标记。它用明确的金属形态制造轻微的视觉停顿，让佩戴者在不需要解释自己的时候，仍然拥有可被感知的存在。"
      }
    ]
  }
];

export const products = [
  {
    "id": "streamline-01",
    "name": "流线01",
    "code": "JM-STREAM-01",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5355-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-02",
    "name": "流线02",
    "code": "JM-STREAM-02",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5356-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-03",
    "name": "流线03",
    "code": "JM-STREAM-03",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5357-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-04",
    "name": "流线04",
    "code": "JM-STREAM-04",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5370-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-05",
    "name": "流线05",
    "code": "JM-STREAM-05",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5371-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-06",
    "name": "流线06",
    "code": "JM-STREAM-06",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5373-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-07",
    "name": "流线07",
    "code": "JM-STREAM-07",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5374-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-08",
    "name": "流线08",
    "code": "JM-STREAM-08",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5375-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-09",
    "name": "流线09",
    "code": "JM-STREAM-09",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5377-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-10",
    "name": "流线10",
    "code": "JM-STREAM-10",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5380-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-11",
    "name": "流线11",
    "code": "JM-STREAM-11",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5384-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-12",
    "name": "流线12",
    "code": "JM-STREAM-12",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5385-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-13",
    "name": "流线13",
    "code": "JM-STREAM-13",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5386-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-14",
    "name": "流线14",
    "code": "JM-STREAM-14",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5387-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-15",
    "name": "流线15",
    "code": "JM-STREAM-15",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5395-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-16",
    "name": "流线16",
    "code": "JM-STREAM-16",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5397-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-17",
    "name": "流线17",
    "code": "JM-STREAM-17",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5398-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-18",
    "name": "流线18",
    "code": "JM-STREAM-18",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5404-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-19",
    "name": "流线19",
    "code": "JM-STREAM-19",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5405-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-20",
    "name": "流线20",
    "code": "JM-STREAM-20",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5409-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-21",
    "name": "流线21",
    "code": "JM-STREAM-21",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5410-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-22",
    "name": "流线22",
    "code": "JM-STREAM-22",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5414-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-23",
    "name": "流线23",
    "code": "JM-STREAM-23",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5417-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-24",
    "name": "流线24",
    "code": "JM-STREAM-24",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5419-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-25",
    "name": "流线25",
    "code": "JM-STREAM-25",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5422-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-26",
    "name": "流线26",
    "code": "JM-STREAM-26",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5424-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-27",
    "name": "流线27",
    "code": "JM-STREAM-27",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5425-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-28",
    "name": "流线28",
    "code": "JM-STREAM-28",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5428-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-29",
    "name": "流线29",
    "code": "JM-STREAM-29",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5470-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-30",
    "name": "流线30",
    "code": "JM-STREAM-30",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5472-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-31",
    "name": "流线31",
    "code": "JM-STREAM-31",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5481-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "streamline-32",
    "name": "流线32",
    "code": "JM-STREAM-32",
    "seriesSlug": "streamline",
    "seriesName": "流线",
    "price": 899,
    "image": "/products/streamline/IMG_5484-web.jpg",
    "description": "流线系列关注线条在身体上的移动感。边缘、弧度与留白被压到克制的比例，让银色结构在日常动作里自然发光。"
  },
  {
    "id": "chain-01",
    "name": "链条01",
    "code": "JM-CHAIN-01",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_5359-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-02",
    "name": "链条02",
    "code": "JM-CHAIN-02",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_5361-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-03",
    "name": "链条03",
    "code": "JM-CHAIN-03",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_8028-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-04",
    "name": "链条04",
    "code": "JM-CHAIN-04",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_8035-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-05",
    "name": "链条05",
    "code": "JM-CHAIN-05",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_8036-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-06",
    "name": "链条06",
    "code": "JM-CHAIN-06",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_8042-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-07",
    "name": "链条07",
    "code": "JM-CHAIN-07",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_8043-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-08",
    "name": "链条08",
    "code": "JM-CHAIN-08",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_8045-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-09",
    "name": "链条09",
    "code": "JM-CHAIN-09",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_8046-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-10",
    "name": "链条10",
    "code": "JM-CHAIN-10",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_8048-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-11",
    "name": "链条11",
    "code": "JM-CHAIN-11",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_8051-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-12",
    "name": "链条12",
    "code": "JM-CHAIN-12",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_8056-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-13",
    "name": "链条13",
    "code": "JM-CHAIN-13",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_8060-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-14",
    "name": "链条14",
    "code": "JM-CHAIN-14",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_8068-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-15",
    "name": "链条15",
    "code": "JM-CHAIN-15",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_8069-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-16",
    "name": "链条16",
    "code": "JM-CHAIN-16",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_8070-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-17",
    "name": "链条17",
    "code": "JM-CHAIN-17",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_8071-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-18",
    "name": "链条18",
    "code": "JM-CHAIN-18",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_8072-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-19",
    "name": "链条19",
    "code": "JM-CHAIN-19",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_8073-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-20",
    "name": "链条20",
    "code": "JM-CHAIN-20",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_8075-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-21",
    "name": "链条21",
    "code": "JM-CHAIN-21",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_8076-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-22",
    "name": "链条22",
    "code": "JM-CHAIN-22",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_8078-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-23",
    "name": "链条23",
    "code": "JM-CHAIN-23",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_8079-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "chain-24",
    "name": "链条24",
    "code": "JM-CHAIN-24",
    "seriesSlug": "chain",
    "seriesName": "链条",
    "price": 960,
    "image": "/products/chain/IMG_8083-web.jpg",
    "description": "链条系列以连接、扣合与重复单元为核心。它像关系的结构图，强调每一个环节之间的支撑，也保留佩戴者自己的节奏。"
  },
  {
    "id": "signal-01",
    "name": "信号01",
    "code": "JM-SIGNAL-01",
    "seriesSlug": "signal",
    "seriesName": "信号",
    "price": 920,
    "image": "/products/signal/IMG_5363-web.jpg",
    "description": "信号系列更像一种标记。它用明确的金属形态制造轻微的视觉停顿，让佩戴者在不需要解释自己的时候，仍然拥有可被感知的存在。"
  },
  {
    "id": "signal-02",
    "name": "信号02",
    "code": "JM-SIGNAL-02",
    "seriesSlug": "signal",
    "seriesName": "信号",
    "price": 920,
    "image": "/products/signal/IMG_5437-web.jpg",
    "description": "信号系列更像一种标记。它用明确的金属形态制造轻微的视觉停顿，让佩戴者在不需要解释自己的时候，仍然拥有可被感知的存在。"
  },
  {
    "id": "signal-03",
    "name": "信号03",
    "code": "JM-SIGNAL-03",
    "seriesSlug": "signal",
    "seriesName": "信号",
    "price": 920,
    "image": "/products/signal/IMG_5439-web.jpg",
    "description": "信号系列更像一种标记。它用明确的金属形态制造轻微的视觉停顿，让佩戴者在不需要解释自己的时候，仍然拥有可被感知的存在。"
  },
  {
    "id": "signal-04",
    "name": "信号04",
    "code": "JM-SIGNAL-04",
    "seriesSlug": "signal",
    "seriesName": "信号",
    "price": 920,
    "image": "/products/signal/IMG_6307-web.jpg",
    "description": "信号系列更像一种标记。它用明确的金属形态制造轻微的视觉停顿，让佩戴者在不需要解释自己的时候，仍然拥有可被感知的存在。"
  },
  {
    "id": "signal-05",
    "name": "信号05",
    "code": "JM-SIGNAL-05",
    "seriesSlug": "signal",
    "seriesName": "信号",
    "price": 920,
    "image": "/products/signal/IMG_6309-web.jpg",
    "description": "信号系列更像一种标记。它用明确的金属形态制造轻微的视觉停顿，让佩戴者在不需要解释自己的时候，仍然拥有可被感知的存在。"
  },
  {
    "id": "signal-06",
    "name": "信号06",
    "code": "JM-SIGNAL-06",
    "seriesSlug": "signal",
    "seriesName": "信号",
    "price": 920,
    "image": "/products/signal/IMG_6316-web.jpg",
    "description": "信号系列更像一种标记。它用明确的金属形态制造轻微的视觉停顿，让佩戴者在不需要解释自己的时候，仍然拥有可被感知的存在。"
  },
  {
    "id": "signal-07",
    "name": "信号07",
    "code": "JM-SIGNAL-07",
    "seriesSlug": "signal",
    "seriesName": "信号",
    "price": 920,
    "image": "/products/signal/IMG_6329-web.jpg",
    "description": "信号系列更像一种标记。它用明确的金属形态制造轻微的视觉停顿，让佩戴者在不需要解释自己的时候，仍然拥有可被感知的存在。"
  },
  {
    "id": "signal-08",
    "name": "信号08",
    "code": "JM-SIGNAL-08",
    "seriesSlug": "signal",
    "seriesName": "信号",
    "price": 920,
    "image": "/products/signal/IMG_6336-web.jpg",
    "description": "信号系列更像一种标记。它用明确的金属形态制造轻微的视觉停顿，让佩戴者在不需要解释自己的时候，仍然拥有可被感知的存在。"
  }
];

export const getProductById = (id) => products.find((product) => product.id === id);

export const getSeriesBySlug = (slug) => productSeries.find((series) => series.slug === slug);
